import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import RenewableEnergy from './components/RenewableEnergy';
import Certifications from './components/Certifications';
import Contact from './components/Contact';
import Footer from './components/Footer';
import OurMission from './components/OurMission';
import { Toaster } from './components/ui/sonner';
import './App.css';

function ScrollToSection() {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
}

function HomePage() {
  const [showFloatingCta, setShowFloatingCta] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setShowFloatingCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <Hero />
      <Services />
      <RenewableEnergy />
      <Certifications />
      <Footer />

      {/* Floating Get a Quote CTA */}
      <button
        data-testid="floating-quote-btn"
        onClick={() => navigate('/contact')}
        className={`fixed bottom-20 right-6 z-40 flex items-center gap-2 bg-gold text-black font-bold px-5 py-3.5 rounded-full shadow-xl shadow-gold/25 hover:shadow-2xl hover:shadow-gold/40 hover:scale-105 transition-all duration-300 ${
          showFloatingCta ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0 pointer-events-none'
        }`}
      >
        <Zap className="w-5 h-5" />
        <span className="text-sm">Get a Quote</span>
      </button>
    </>
  );
}

function ContactPage() {
  return (
    <>
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <ScrollToSection />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mission" element={<OurMission />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
